import { cn } from '../../lib/cn';

/**
 * Colour discipline (plan §2.2): colour is spent only on states that must catch the eye.
 * Expected/normal states use `muted`, so anything coloured is genuinely notable.
 */
export type StatusTone = 'muted' | 'danger' | 'warning' | 'success' | 'info';

export const STATUS_TONE_COLORS: Record<Exclude<StatusTone, 'muted'>, string> = {
  danger: '#dc2626',
  warning: '#a16207',
  success: '#15803d',
  info: '#2563eb',
};

export interface StatusTextProps {
  label: string;
  /** Explicit hex override; wins over `tone`. */
  color?: string;
  tone?: StatusTone;
  className?: string;
}

export const StatusText = ({ label, color, tone = 'muted', className }: StatusTextProps) => {
  const resolvedColor = color ?? (tone === 'muted' ? undefined : STATUS_TONE_COLORS[tone]);

  return (
    <span
      className={cn('text-sm font-medium', resolvedColor ? undefined : 'text-muted-foreground', className)}
      style={resolvedColor ? { color: resolvedColor } : undefined}
    >
      {label}
    </span>
  );
};
